import {
    faBalanceScale,
    faBan,
    faCalendar,
    faChevronDown,
    faCircleNotch,
    faCommentAlt,
    faFile,
    faFileArchive,
    faFileInvoiceDollar,
    faLaptop,
    faQuestion,
    faSearchMinus,
    faShoppingBag,
    faStopCircle,
    faTasks,
    faUserFriends,
    faUsersCog,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { useUserInfor } from "../../../../../Context/User";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../../Validations/UsuarioTela";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import MotivoCancelamento from "../../../CobrancaTab/subnavs/MotivoCancelamento";
import { TipoAgendamento } from "../GestaoCadastro/TipoAgendamento";
import TipoCanalAtendimento from "../GestaoCadastro/TipoCanalAtendimento";
import TipoDocumento from "../GestaoCadastro/TipoDocumento";
import TipoPesoAtendimento from "../GestaoCadastro/TipoPesoAtendimento";
import TipoRecorrencia from "../GestaoCadastro/TipoRecorrencia";
import TipoRelacaoCliente from "../GestaoCadastro/TipoRelacaoCliente";
import TipoDocumentoPorEtapa from "../TipoDocumentoEtapa";
import TipoCliente from "../GestaoCadastro/TipoCliente";
import TipoAtividades from "../TipoAtividades";
import MotivoCompra from "../MotivoCompra";
import MotivoParalisacao from "../MotivoParalisacao";
import MotivoProblema from "../MotivoProblema";
import MotivoNaoProcedencia from "../MotivoNaoProcedencia";
import { NavLink } from "react-router-dom";

interface ICadastroTipos {
    SetShow: Dispatch<SetStateAction<boolean>>;
    show: boolean;
    SetModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    Modal: IComponentModal | undefined;
}

export function CadastroTipos(props: ICadastroTipos) {
    const { UserInfor } = useUserInfor();

    return (
        <div className="card">
            <div className="card-header p-6" id="headingOne">
                <span className="mb-0 d-flex justify-content-center align-items-center span-style">
                    <button
                        className="d-flex justify-content-center align-items-center w-100 border-0 buttonBgWhite"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                    >
                        <FontAwesomeIcon className="mr-2" icon={faLaptop} />
                        Cadastro de Tipos
                        <FontAwesomeIcon
                            className="ml-1"
                            size={"sm"}
                            icon={faChevronDown}
                        />
                    </button>
                </span>
            </div>

            <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
            >
                <ul className="menu-subnav pt-3">
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.GERAL.MODAIS.TIPO_DOCUMENTO_ETAPA
                                      .ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item a-hover-none"
                                      >
                                          <a
                                              href="#/"
                                              className="menu-link a-hover-none"
                                              onClick={() => {
                                                  props.SetShow(true);
                                                  props.SetModal({
                                                      headerComponent:
                                                          "Tipos de Documento por Etapa",
                                                      IconHeader: faFileArchive,
                                                      Children: (
                                                          <TipoDocumentoPorEtapa />

                                                          //   FL_DINAMICO={true}
                                                          //   ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO={
                                                          //       1
                                                          //   }
                                                          //   ID_ETAPA_TIPO_CASO={1}
                                                          //   ID_TIPO_DOCUMENTO={0}
                                                      ),
                                                      collapseForm: true,
                                                      size: "xl",
                                                  });
                                              }}
                                          >
                                              <span className="svg-icon menu-icon">
                                                  <FontAwesomeIcon
                                                      icon={faFileArchive}
                                                  />
                                              </span>
                                              <span className="textBlue">
                                                  Tipos de Documento por Etapa
                                              </span>
                                          </a>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                </ul>

                <ul className="menu-subnav">
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.GERAL.MODAIS.TIPO_CANAL_ATENDIMENTO
                                      .ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item a-hover-none"
                                      >
                                          <a
                                              href="#/"
                                              className="menu-link a-hover-none"
                                              onClick={() => {
                                                  props.SetShow(true);
                                                  props.SetModal({
                                                      headerComponent:
                                                          "Tipo Canal Atendimento",
                                                      IconHeader: faCommentAlt,
                                                      Component:
                                                          TipoCanalAtendimento,
                                                      collapseForm: true,
                                                  });
                                              }}
                                          >
                                              <span className="svg-icon menu-icon">
                                                  <FontAwesomeIcon
                                                      icon={faCommentAlt}
                                                  />
                                              </span>
                                              <span className="textBlue">
                                                  Tipo Canal Atendimento
                                              </span>
                                          </a>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                </ul>
                <ul className="menu-subnav">
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.GERAL.MODAIS.TIPO_RECORRENCIA.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item a-hover-none"
                                      >
                                          <a
                                              href="#/"
                                              className="menu-link a-hover-none"
                                              onClick={() => {
                                                  props.SetShow(true);
                                                  props.SetModal({
                                                      headerComponent:
                                                          "Tipo Recorrencia",
                                                      IconHeader: faCircleNotch,
                                                      Component:
                                                          TipoRecorrencia,
                                                      collapseForm: true,
                                                  });
                                              }}
                                          >
                                              <span className="svg-icon menu-icon">
                                                  <FontAwesomeIcon
                                                      icon={faCircleNotch}
                                                  />
                                              </span>
                                              <span className="textBlue">
                                                  Tipo Recorrencia
                                              </span>
                                          </a>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                </ul>
                <ul className="menu-subnav">
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.GERAL.MODAIS.TIPO_DOCUMENTO.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item a-hover-none"
                                      >
                                          <a
                                              href="#/"
                                              className="menu-link a-hover-none"
                                              onClick={() => {
                                                  props.SetShow(true);
                                                  props.SetModal({
                                                      headerComponent:
                                                          "Tipo Documento",
                                                      IconHeader: faFile,
                                                      Component: TipoDocumento,
                                                      collapseForm: true,
                                                  });
                                              }}
                                          >
                                              <span className="svg-icon menu-icon">
                                                  <FontAwesomeIcon
                                                      icon={faFile}
                                                  />
                                              </span>
                                              <span className="textBlue">
                                                  Tipo Documento
                                              </span>
                                          </a>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                </ul>
                <ul className="menu-subnav">
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.GERAL.MODAIS.TIPO_AGENDAMENTO.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item a-hover-none"
                                      >
                                          <a
                                              href="#/"
                                              className="menu-link a-hover-none"
                                              onClick={() => {
                                                  props.SetShow(true);
                                                  props.SetModal({
                                                      headerComponent:
                                                          "Tipo Agendamento",
                                                      IconHeader: faCalendar,
                                                      Component:
                                                          TipoAgendamento,
                                                      collapseForm: true,
                                                  });
                                              }}
                                          >
                                              <span className="svg-icon menu-icon">
                                                  <FontAwesomeIcon
                                                      icon={faCalendar}
                                                  />
                                              </span>
                                              <span className="textBlue">
                                                  Tipo Agendamento
                                              </span>
                                          </a>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                </ul>

                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.TIPO_RELACAO_CLIENTE.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        headerComponent: "Tipo Relação Cliente",
                                        IconHeader: faUserFriends,
                                        Component: TipoRelacaoCliente,
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faUserFriends} />
                                </span>
                                <span className="textBlue">
                                    Tipo Relação Cliente
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.TIPO_PESO_ATENDIMENTO.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: TipoPesoAtendimento,
                                        size: "lg",
                                        collapseForm: true,
                                        IconHeader: faBalanceScale,
                                        headerComponent:
                                            "Tipo Peso de Atendimento",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faBalanceScale} />
                                </span>
                                <span className="textBlue">
                                    Tipo de Peso de Atendimento
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.GESTAO_TEMPLATES.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: TipoCliente,
                                        size: "lg",
                                        collapseForm: true,
                                        IconHeader: faUsersCog,
                                        headerComponent: "Perfil Tipo Cliente",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faUsersCog} />
                                </span>
                                <span className="textBlue">Tipo Cliente</span>
                            </a>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.GESTAO_TEMPLATES.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: TipoAtividades,
                                        size: "lg",
                                        collapseForm: true,
                                        IconHeader: faTasks,
                                        headerComponent: "Tipo Atividade",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faTasks} />
                                </span>
                                <span className="textBlue">Tipo Atividade</span>
                            </a>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.GESTAO_TIPO_PARCELAS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <NavLink
                                to={
                                    ACESSOS.GERAL.TELAS.GESTAO_TIPO_PARCELAS
                                        .DS_PATH
                                }
                                activeClassName="menu-link-active"
                                className="menu-link a-hover-none"
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faFileInvoiceDollar} />
                                </span>
                                <span className="textBlue">
                                    Tipo de Parcelas
                                </span>
                            </NavLink>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav">
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.GERAL.MODAIS.MOTIVO_CANCELAMENTO
                                      .ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item a-hover-none"
                                      >
                                          <a
                                              href="#/"
                                              className="menu-link a-hover-none"
                                              onClick={() => {
                                                  props.SetShow(true);
                                                  props.SetModal({
                                                      headerComponent:
                                                          "Motivo Cancelamento",
                                                      IconHeader: faBan,
                                                      Component:
                                                          MotivoCancelamento,
                                                      collapseForm: true,
                                                  });
                                              }}
                                          >
                                              <span className="svg-icon menu-icon">
                                                  <FontAwesomeIcon
                                                      icon={faBan}
                                                  />
                                              </span>
                                              <span className="textBlue">
                                                  Motivo Cancelamento
                                              </span>
                                          </a>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                </ul>
                <ul className="menu-subnav pb-3">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.TIPO_PESO_ATENDIMENTO.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: MotivoCompra,
                                        size: "lg",
                                        collapseForm: true,
                                        IconHeader: faShoppingBag,
                                        headerComponent: "Motivo de Compra",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faShoppingBag} />
                                </span>
                                <span className="textBlue">
                                    Motivo de Compra
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav pb-3">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.TIPO_PESO_ATENDIMENTO.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: MotivoParalisacao,
                                        size: "lg",
                                        collapseForm: true,
                                        IconHeader: faStopCircle,
                                        headerComponent:
                                            "Motivo da Paralisação",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faStopCircle} />
                                </span>
                                <span className="textBlue">
                                    Motivo da Paralisação
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav pb-3">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.MOTIVO_NAO_PROCEDENCIA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: MotivoNaoProcedencia,
                                        size: "lg",
                                        collapseForm: true,
                                        IconHeader: faSearchMinus,
                                        headerComponent:
                                            "Motivo Não Procedência",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faSearchMinus} />
                                </span>
                                <span className="textBlue">
                                    Motivo Não Procedência
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav pb-3">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.MOTIVO_PROBLEMA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: MotivoProblema,
                                        size: "xl",
                                        collapseForm: true,
                                        IconHeader: faQuestion,
                                        headerComponent: "Motivo Problema",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faQuestion} />
                                </span>
                                <span className="textBlue">
                                    Motivo Problema
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
